<script>
  export let data;

  /**
   * An array of types with merchant and webshop information.
   * @type {Array<{ merchant: { name: string, image_url: string }, webshop: { name: string, image_url: string } }>}
   */
  export let types;

  /**
   * Whether to show or hide type images.
   * @type {boolean}
   */
  export let showImage = true;
</script>

<div class="tags">
  <span class="type">
    {#each types as type}
      {#if data.type == 'merchant'}
        {#if showImage}
          <img src={type.merchant.image_url} alt="merchant" />
        {/if}
        {type.merchant.name}
      {:else}
        {#if showImage}
          <img src={type.webshop.image_url} alt="webshop" />
        {/if}
        {type.webshop.name}
      {/if}
    {/each}
  </span>
  <span class="category">{data.category.name}</span>
</div>
